<script setup lang="ts">
import type { RegionHeroProps } from '.';

import { Container } from '@/components/Container';

defineProps<RegionHeroProps>();
</script>

<!-- eslint-disable vue/no-v-html -->
<template>
	<section class="relative h-[37.5rem] w-full bg-primary">
		<NuxtImg
			v-if="backgroundImage"
			:src="backgroundImage"
			width="1440"
			height="600"
			sizes="xs:375px sm:640px md:768px lg:1024px xl:1280px 2xl:1440px"
			densities="x1"
			loading="lazy"
			format="webp"
			:placeholder="[50, 25]"
			class="absolute inset-0 size-full object-cover object-center"
			fetchpriority="high"
			decoding="async"
		/>
		<div
			class="absolute inset-0 bg-[linear-gradient(0deg,rgba(0,0,0,0.32)_0%,rgba(0,0,0,0.32)_100%)]"
		/>
		<Container
			class="relative flex size-full max-h-[37.5rem] flex-1 flex-col items-start justify-end py-8 2xl:py-12"
		>
			<div class="flex flex-col gap-3 2xl:gap-5">
				<Skeleton :is-active="isLoading" class="h-11 min-w-[205px]">
					<h2
						class="font-matter-sq text-[2.5rem] font-normal leading-[140%] tracking-[-0.06rem] text-white 2xl:text-5xl 2xl:leading-[110%]"
					>
						{{ title }}
					</h2>
				</Skeleton>

				<!-- eslint-disable-next-line vue/no-v-html -->
				<div class="max-w-[38.3125rem]">
					<div v-if="isLoading" class="space-y-2">
						<Skeleton is-active class="h-5 w-full" />
						<Skeleton is-active class="h-5 w-2/3" />
					</div>

					<p
						v-else
						class="text-base font-normal text-white 2xl:text-xl"
						v-html="description"
					/>
				</div>
			</div>
		</Container>
	</section>
</template>
